export default __webpack_public_path__ + "static/media/main_item_05.f2b72f6a.png";